import React from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  IconButton,
  CardContent,
} from "@mui/material";
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Place as PlaceIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from "@mui/icons-material";
import StopStatusChip from "./StopStatusChip";
import OrderItem from "./OrderItem";

const StopCard = ({
  stop,
  isCompleted,
  isCurrent,
  isNext,
  isExpanded,
  onToggle,
}) => {
  const deliveredCount = stop.total_delivered_order || 0;
  const failedOrders = stop.orders.filter(
    (o) => o.status?.toLowerCase() === "failed"
  );
  const failedCount = failedOrders.length;
  const failedReasons = failedOrders
    .map((o) => o.order_reason)
    .filter(Boolean)
    .join(", ");
  const totalCount = stop.orders.length;
  const returnedCount = stop.returns_orders || 0;
  const partialReturnedCount = stop.partial_orders || 0;

  return (
    <Box sx={{ mb: isCompleted ? 2 : 4, position: "relative" }}>
      {/* Timeline connector line */}
      {!isCompleted && (
        <Box
          sx={{
            position: "absolute",
            left: 24,
            top: 60,
            bottom: 0,
            width: 2,
            backgroundColor: "grey.300",
            zIndex: 0,
          }}
        />
      )}
      {/* TODO: Need to update isNext once API provides correct next stop info */}
      <Paper
        elevation={isCurrent ? 4 : isNext ? 2 : 1}
        sx={{
          position: "relative",
          border:
            // isNext
            //   ? "2px solid #1976d2"
            //   :
            isCompleted ? "2px solid #4caf50" : "2px solid #e0e0e0",
          "&:hover": {
            boxShadow: 3,
          },
        }}
      >
        {/* Stop indicator dot */}
        <Box
          sx={{
            position: "absolute",
            left: -18,
            top: 24,
            width: 36,
            height: 36,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1,
            backgroundColor:
              // isNext
              // ? "#1976d2"
              // :
              isCompleted ? "#4caf50" : "#bdbdbd",
            ...(isNext && {
              boxShadow: "0 0 0 4px rgba(255, 167, 38, 0.2)",
            }),
          }}
        >
          <Typography variant="subtitle2" color="white" fontWeight="bold">
            {stop.stopNumber}
          </Typography>
        </Box>

        <CardContent sx={{ pl: 8 }}>
          {/* Stop Header */}
          <Grid
            container
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <Grid item xs={8}>
              <Grid container alignItems="center" spacing={1} sx={{ mb: 1 }}>
                <Grid item>
                  <PlaceIcon fontSize="small" />
                </Grid>
                <Grid item>
                  <Typography variant="h6" fontWeight="bold">
                    {stop.location.split(",")[0]}
                  </Typography>
                </Grid>
                <Grid item>
                  <StopStatusChip status={stop.status} />
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <IconButton onClick={onToggle} size="small">
                {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </Grid>
          </Grid>

          {/* Orders Summary */}
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item>
              <Typography variant="body2" color="text.secondary">
                <strong>{totalCount}</strong> order{totalCount !== 1 ? "s" : ""}
              </Typography>
            </Grid>
            {deliveredCount > 0 && (
              <Grid item display="flex" alignItems="center">
                <CheckCircleIcon
                  fontSize="small"
                  color="success"
                  sx={{ mr: 0.5 }}
                />
                <Typography variant="body2" color="success.main">
                  {deliveredCount} delivered
                </Typography>
              </Grid>
            )}
            {returnedCount > 0 && (
              <Grid item display="flex" alignItems="center">
                <Typography variant="body2" sx={{ color: "black" }}>
                  Returned: {returnedCount}
                </Typography>
              </Grid>
            )}
            {partialReturnedCount > 0 && (
              <Grid item display="flex" alignItems="center">
                <Typography variant="body2" sx={{ color: "black" }}>
                  Partial: {partialReturnedCount}
                </Typography>
              </Grid>
            )}
            {failedCount > 0 && (
              <Grid item display="flex" alignItems="center">
                <CancelIcon fontSize="small" color="error" sx={{ mr: 0.5 }} />
                <Typography variant="body2" color="error.main">
                  {failedCount} failed
                  {failedReasons && ` - ${failedReasons}`}
                </Typography>
              </Grid>
            )}
          </Grid>

          {/* Orders List */}
          {isExpanded && (
            <Box>
              {stop.orders.map((order) => (
                <OrderItem
                  key={order.orderId}
                  order={order}
                  expanded={isExpanded}
                />
              ))}
            </Box>
          )}
        </CardContent>
      </Paper>
    </Box>
  );
};

export default StopCard;